/**
 * Another app can open this storefront with a search already typed: WeHunt
 * Web's top bar submits to `/go/shop?q=<term>`, GoShopRoute carries the query
 * string to the localized home, and the layout opens the search overlay with
 * the term. The parameter is read once and then stripped, so a reload or a
 * shared link does not keep re-opening the overlay.
 */
export const SEARCH_QUERY_PARAM = "q";

export interface SearchEntry {
  /** The term to open the overlay with, or null when the URL carries none. */
  query: string | null;
  /** The query string with the term removed — "" when nothing else was there. */
  search: string;
}

export function readSearchEntry(search: string): SearchEntry {
  const params = new URLSearchParams(search);
  const raw = params.get(SEARCH_QUERY_PARAM);
  if (raw === null) return { query: null, search };
  params.delete(SEARCH_QUERY_PARAM);
  const rest = params.toString();
  const trimmed = raw.trim();
  // An empty `?q=` is still consumed (so it is stripped) but opens nothing.
  return { query: trimmed ? trimmed : null, search: rest ? `?${rest}` : "" };
}
